import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjectCommunicationService } from '../communication/project-comms.service';

@Injectable({
  providedIn: 'root'
})
export class ResultsGuard  {
  constructor(private projectCommService: ProjectCommunicationService,
              private router: Router
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.projectCommService.getProjectLoaded()) {
      if (this.projectCommService.project.projectInfo.useFinancial) {
        return true;
      } else {
        this.router.navigateByUrl('/results');
        return false;
      }
    }
    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
      if (this.projectCommService.getProjectLoaded()) {
        if (this.projectCommService.project.projectInfo.useFinancial) {
          return true;
        } else {
          this.router.navigateByUrl('/results');
          return false;
        }
      }
      return true;
  }
}
